const apiUrl = import.meta.env.VITE_API_URL as string;
const env = import.meta.env.VITE_ENV as string;
const showLayout = import.meta.env.VITE_SHOW_LAYOUT as string;
const isDebugging = import.meta.env.VITE_IS_DEBUG as string;
const domainUrl = import.meta.env.VITE_DOMAIN_URL as string;
const v4OrderDetailsUrl = import.meta.env.VITE_ORDER_DETAILS_HOST as string;
const yarpHost = import.meta.env.VITE_YARP_HOST as string;
const selectedEnvironment = import.meta.env.VITE_SELECTED_ENVIRONMENT as string;
const v3Host = import.meta.env.VITE_V3HOST as string;
const viteUseV3RouteInjection = import.meta.env
  .VITE_USEV3ROUTEINJECTION as string;
const appVersion = import.meta.env.VITE_APP_VERSION as string;
const agGridLicensePicks =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-074772}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Armstrong_Transport_Group}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_March_2026}____[v3]_[01]_MTc3MzQ0NjQwMDAwMA==6af921f8000273189fd966520ba238ff';
const falveyUrl = import.meta.env.VITE_FALVEY_API_URL as string;
const pdfApiUrl = import.meta.env.VITE_PDF_API_URL as string;
const showPdfBtn = import.meta.env.VITE_SHOW_PDF_BUTTON as string;

export const ConfigManager = {
  apiUrl,
  env,
  showLayout: !!(showLayout && showLayout.toLowerCase() === 'true'),
  isDebugging: isDebugging,
  domainUrl: domainUrl,
  agGridLicensePicks,
  v4OrderDetailsHost: v4OrderDetailsUrl,
  yarpHost,
  viteUseV3RouteInjection,
  v3Host,
  selectedEnv: selectedEnvironment,
  falveyUrl,
  appVersion,
  pdfApiUrl,
  showPdfBtn: !!(showPdfBtn && showPdfBtn.toLowerCase() === 'true'),
};
